import './style.scss';

import { ChangePasswordModal } from '../changePassword/modal';
import { AgreementDocumentModal } from '../agreementDocument/modal';

import { NavLink, Outlet, ScrollRestoration } from 'react-router-dom';
import { CenterNav } from 'views/components/organisms/centerNav';
import { SideMenuPc, SideMenuSP } from 'views/components/organisms/leftNav';
import { GlobalLoading } from 'views/components/organisms/globalLoading';
import { GlobalToast } from 'views/components/organisms/globalToast';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';

import { PasskeySuggestionModal } from './modal';
import { ForceInputStep, useLayout } from './hooks';

export const Layout = () => {
  const { step, showPasskeySuggestHeader, changePasswordComplete, mfaSuggestionComplete } = useLayout();

  if (step === ForceInputStep.ChangePassword) {
    return <ChangePasswordModal isModal={true} onCompleted={changePasswordComplete} />;
  }

  return (
    <div className="body">
      <ScrollRestoration />
      <SideMenuPc />
      <SideMenuSP />
      <div className="mainContent">
        <CenterNav />
        {showPasskeySuggestHeader && <PasskeySuggestHeader />}
        <Outlet />
        {step === ForceInputStep.NotLogin && <></>}
        {step === ForceInputStep.MFASuggest && <PasskeySuggestionModal onCompleted={mfaSuggestionComplete} />}
        {step === ForceInputStep.AgreementDocument && <AgreementDocumentModal />}
      </div>
      <GlobalLoading />
      <GlobalToast />
    </div>
  );
};

const PasskeySuggestHeader = () => {
  return (
    <div className="passkeySuggestHeader">
      <span className="passkeySuggestHeader_icon" aria-hidden="true">
        !
      </span>
      <span className="passkeySuggestHeader_text">セキュリティ強化のため</span>
      <NavLink className="passkeySuggestHeader_link" to={`${CustomerPagePath.SecuritySetting}?tab=1`}>
        パスキー認証の登録
      </NavLink>
      <span className="passkeySuggestHeader_text">をお願いします</span>
    </div>
  );
};
